import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import { Button, Typography } from "@mui/material";
import { ReactComponent as IconPlus } from "../../common/assets/images/iconPlus.svg";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles(theme => ({
  addPeerGroup: {
    "marginTop": "1rem",
    "display": "flex",
    "width": "fit-content",
    "height": "fit-content",
    "cursor": "pointer",
    "padding": 0,
    "& svg": {
      marginRight: "1rem",
      height: 80,
      width: 80,
    },
    "& div": {
      "padding": "1rem 0",
      "& p": {
        textAlign: "left",
        color: theme.palette.primary.main,
        fontWeight: 700,
        fontSize: "1.25rem",
      },
    },
    "&:hover, &.Mui-focusVisible": {
      "backgroundColor": "transparent",
      "& #Rectangle-Copy-3": {
        fill: theme.palette.primary.main,
        stroke: "#a58922",
      },
      "& #Combined-Shape": {
        fill: "#ffffff",
      },
    },
  },
}));

interface Props {
  title: string;
  path: string;
  onClick?: () => void;
}
function AddButton({ title, path, onClick }: Props) {
  const classes = useStyles();
  const history = useHistory();
  return (
    <Button
      className={classes.addPeerGroup}
      onClick={() => {
        onClick?.();
        history.push({
          pathname: path,
        });
      }}
    >
      <IconPlus />
      <div>
        <Typography>{title}</Typography>
      </div>
    </Button>
  );
}
export default AddButton;
